<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#191F40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.58579 8.41421L2 14L4 16L4.02376 15.9767C5.13129 14.8905 6.90702 14.8992 8.00391 15.9961C9.1008 17.093 9.10945 18.8687 8.0233 19.9762L8 20L10 22L15.5858 16.4142L7.58579 8.41421ZM10.4142 5.58579L18.4142 13.5858L22 10L20 8L19.9524 8.04574C18.8417 9.11183 17.0824 9.0936 15.9941 8.00472C14.9052 6.91521 14.8887 5.15458 15.9569 4.0448L16 4L14 2L10.4142 5.58579Z"
      stroke="#191F40"
    />
  </svg>
</template>

<script setup lang="ts"></script>
